import store from "../store";
import axios from 'axios';
import router from "../router";
import {
  Message
} from 'element-ui'
// 配置API接口地址
//var root = "https://localhost:44319/api/";
//var root = "https://smartapprovalapi-uat.adidas.com.cn/api/"
var root = "https://smartapprovalapi.adidas.com.cn/api/"
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      if (o[key] == '') {
        delete o[key];
      } else {
        o[key] = o[key].trim();
      }
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}

// http request 拦截器
var storeTemp = store;
axios.interceptors.request.use(
  config => {
    if (window.localStorage.getItem("SmartAPPToken")) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + window.localStorage.getItem("SmartAPPToken");
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          store.commit("saveToken", "");
          window.localStorage.setItem("SmartAPPToken", "");
          router.push({ path: "/" });
          // window.location.href = "https://smartapproval-dev.adidas.com.cn"
          break;
        case 403:
          Message({
            message: 'No right to View',
            type: 'error',
            duration: 5 * 1000
          })
          router.push({ path: '/Blank' })
          break;

      }
    }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/
function apiAxios(method, url, params, type = 'json', header = 'application/json') {
  if (params) {
    params = filterNull(params);
  }
  return new Promise((resolve, reject) => {
    axios(
      {
        method: method,
        url: url,
        data: method === "POST" || method === "PUT" ? params : null,
        params: method === "GET" || method === "DELETE" ? params : null,
        baseURL: root,
        responseType: type,
        timeout: 1000 * 60 * 20,
        headers: {
          'Content-Type': header
        },
        // `headers` 是即将被发送的自定义请求头
        withCredentials: false
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch(function (error) {
        reject(error);
      });
  });

}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, type, header) {
    if (params != null) {
      Object.defineProperty(params, "timestamp", {
        value: new Date().getTime(),
        configurable: true,
        enumerable: true,
        writable: true
      })
    }
    return apiAxios("GET", url, params, type, header);
  },
  post: function (url, params, type, header) {
    return apiAxios("POST", url, params, type, header);
  },
  put: function (url, params, type, header) {
    return apiAxios("PUT", url, params, type, header);
  },
  delete: function (url, params, type, header) {
    return apiAxios("DELETE", url, params, type, header);
  }
};



// WEBPACK FOOTER //
// ./src/api/http.js